// Shopify policy 5.2.12 prohibits promotional or upselling content within the payment flow.
// Channels listed here replace "Powered by viva.com" (with link) with "Payments by viva.com" (no link)
// to comply with partner store policies. Add new channel IDs here as needed.
const SHOPIFY_PLUGIN_CHANNEL_ID = '4c09857a-c6e7-4b32-b589-202f323c301e';

export const NON_PROMOTED_CHANNEL_IDS = new Set([
    SHOPIFY_PLUGIN_CHANNEL_ID
]);